import React from 'react'
import Select from './Select'

export const STATUSES = [
  { id: 'all', name: 'Approval: all' },
  { id: 'true', name: 'Approved' },
  { id: 'false', name: 'Not approved' },
]

export default function ApprovalStatusSelect(props) {
  return <Select {...props} options={STATUSES} />
}
